import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center font-body text-[#5C5C5C]">Carregando...</div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    return children;
}
